import { useCallback, useInsertionEffect, useRef } from 'react';

/**
 * Безусловный useCallback, который всегда возвращает постоянную функцию.
 * !!!Важно! Эту функцию нельзя использовать на этапе рендера (например передавать в render-prop),
 * а так же использовать внутри useInsertionEffect в дочерних элементах
 * @param func функция
 * @returns мемоизованная функция
 */
export function usePersistentCallback<T extends undefined | null | ((...args: never[]) => unknown)>(
    func: T,
): T {
    const refCallee = useRef(func);

    useInsertionEffect(() => {
        refCallee.current = func;
    });

    const callback = useCallback((...args: never[]) => refCallee.current?.(...args), []) as T;

    return func && callback;
}
